import { httpClient } from "./httpClient";

const getAllWorkTypes = () => {
    return httpClient.get(`workingTypes`);
};

export default {
    getAllWorkTypes
}